import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, OccEndpointsService, UserIdService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export interface ContactUsWsDTO {
  firstName: string;
  lastName: string;
  email: string;
  contactNumber: string;
  requestType: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  baseSite$: Observable<string> = this.baseService.getActive();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  constructor(
    protected http: HttpClient,
    protected auth: UserIdService,
    protected authStorageService: AuthStorageService,
    protected baseService: BaseSiteService,
    protected meta: Meta,
    private occEndpointsService: OccEndpointsService
  ) {}

  postContactUsForm(formDetails: ContactUsWsDTO): Observable<any> {
    const httpOptions = {
      headers: this.headers,
      observe: 'response' as 'response',
    };

    return this.auth.getUserId().pipe(
      switchMap((userCurrent) => {
        return this.http
          .post(this.occEndpointsService.buildUrl(`/users/${userCurrent}/contact-us`), formDetails, httpOptions)
          .pipe(catchError(this.errorHandl));
      })
    );
  }

  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
